import { createFileRoute, redirect } from '@tanstack/react-router';

/* /settings has no content of its own — the first tab is the landing section. */
export const Route = createFileRoute('/_app/settings/')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/profile' });
  },
});
